import { TenantStateSetterContext } from "../../contexts/tenant-context-provider";
import { useContextSafely } from "../../utils/react-utils";

/**
 * A hook that returns a state setter function to update the active tenant for the `TenantProvider`.
 *
 * Updating the `TenantProvider` active tenant will cause any components under this provider
 * that uses its tenant value via the `useTenant()` hook to re-render.
 *
 * @param suppressErrorMessage Suppress console error message when the hook is used without `LocalizedTextProvider`.
 */
export function useSetTenant(suppressErrorMessage?: boolean) {
  return useContextSafely(TenantStateSetterContext, suppressErrorMessage, useSetTenant.name);
}
